import api from 'Application/api/api';

const selectProjectTopic = (projectId, topicId, cancelToken = null) =>
    api.post(
        `project-manager/projects/${projectId}/topics/${topicId}/select`,
        {},
        { cancelToken },
    );

export default selectProjectTopic;
